import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// Styles
import styles from './index.module.sass';
import { styled } from '@mui/material/styles';

const date = new Date();

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002747',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 100,
    backgroundColor: '#002747',
  },
});

type Props = {
  node: Object,
  getOrder: Function,
  device: Object,
};

function renderItem({
  imagen,
  descri,
  clave,
  cantidad,
  letra,
  precio,
  importe,
  status,
  onQuantityChange,
  screenSize,
  loading,
  agrupador,
  t,
}) {
  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <div className={styles.image}>
        <img src={`${imagen}?x=${date.getFullYear()}${date.getMonth() + 1}`} alt={descri} />
      </div>
      <div className={styles.mobil}>
        <div className={styles.itemName}>
          <div className={styles.name}>
            <label className={styles.idname}>
              <label className={styles.id}>{clave}</label> -{' '}
              <label className={styles.descri}>{descri}</label>
              {agrupador === 'COMPONENTES' && (
                <lable className={styles.descri}> ({t('isComponent')})</lable>
              )}
              {agrupador === 'REGALOS' && <lable className={styles.descri}> ({t('isGift')})</lable>}
              {agrupador === 'TAX' && <span className={styles.name}> ({t('isTax')})</span>}
            </label>
          </div>
        </div>

        <div className={styles.totals}>
          <div className={`${styles.column}`}>
            {t('tableRowUni')} <br />
            {cantidad}
          </div>
          <div className={`${styles.column}`}>
            {t('tableRowLetter')} <br />
            {letra}
          </div>
          <div className={`${styles.column}`}>
            {t('tableRowPrice')} <br />${precio}
          </div>
          <div className={`${styles.column}`}>
            {t('tableRowAmount')} <br />${importe}
          </div>
          {status !== '' && (
            <div className={`${styles.column}`}>
              <div className={styles.alert}>
                <CustomWidthTooltip title={status} placement='right' arrow>
                  {
                    <span className={`material-icons-outlined ${styles.tooltip}`}>
                      report_problem
                    </span>
                  }
                </CustomWidthTooltip>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function TableRowMobile({ node, getOrder, device }: Props): React$Node {
  const {
    imagen = '',
    clave = '',
    descri = '',
    cantidad = '',
    letra = '',
    precio = '',
    importe = '',
    status = '',
    categoria = '',
    numeroLinea = '',
    agrupador = '',
  } = node;

  const [loading, setloading] = useState(false);

  const screenSize = device?.screenSize || 'desktop';
  const { t } = useTranslation('order');

  async function onQuantityChange(action) {
    let result;
    if (action === 'add')
      result = await getOrder(
        'ORDENAR',
        categoria,
        clave,
        parseInt(cantidad) + 1,
        numeroLinea,
        false,
      );
    else if (action === 'delete') {
      setloading(true);
      result = await getOrder(
        'BORRARPRO',
        categoria,
        clave,
        parseInt(cantidad),
        numeroLinea,
        false,
      );
      console.log(result);
      setloading(false);
    } else {
      if (parseInt(cantidad) <= 1) return;
      else
        result = await getOrder(
          'ORDENAR',
          categoria,
          clave,
          parseInt(cantidad) - 1,
          numeroLinea,
          false,
        );
    }
  }
  return (
    <div>
      {renderItem({
        imagen,
        descri,
        clave,
        cantidad,
        letra,
        precio,
        importe,
        status,
        onQuantityChange,
        screenSize,
        loading,
        agrupador,
        t,
      })}
    </div>
  );
}
